<template>
  <div id="app">
    <router-view> </router-view>
  </div>
</template>

<script>
export default {
  name: "app",
  created() {
    const that = this;
    // that.GetData('SYS/GetHost',{},function(res){
		// 		that.HostUrl = res.data.host;
    //     console.log(that.HostUrl)
		// })
    
    // this.signalr.off('GetUsersResponse');
    // this.signalr.on('GetUsersResponse',res=>{
    //   //可以做相关业务逻辑
    //     console.log(res);
    //     that.$notify.info({
    //       title: '消息',
    //       message: res
    //     });
    // })
    // this.signalr.start().then(res=>{
    //   console.log(res)
    //   this.signalr.invoke('GetUsers').catch(e=>{
    //     console.log(e)
    //   })
    // }).catch(err => {
    //   console.log(err);
    // });
    //这里Show就是在服务端指定的Show的方法名称，这里是先清除，再加上
  },
  mounted () {
    // this.signalr.start().then(() => {
    //     console.log('连接');
    // })
  }
};
</script>

<style lang="less">
html,
body {
  width: 100%;
  height: 100%;
  margin: 0;
}
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  // text-align: center;
  color: #2c3e50;
}
.toptitle {
  background-color: #0062ab;

  color: white;
  font-size: 15px;
  text-align: left;
  .tit {
    font-weight: bold;
  }
}

.el-form-item {
  text-align: left;
  margin-bottom: 10px;
}
  .el-tree-node__content {
    padding: 8px 0;
  }
  .el-card__body{
    padding: 3px;
  }
  .el-tabs__header {
    padding: 0;
    position: relative;
    margin: 0 0 5px;
    
  }
  .el-drawer__body {
    flex: 1;
    overflow: auto;
  }
  .el-input-number--mini {
      width: 100px;
      line-height: 26px;
  }

.el-dialog__body{
  padding: 10px;
    color: #606266;
    font-size: 14px;
    word-break: break-all;
}
.tabs .el-tabs__header {
    padding: 0;
    position: relative;
    margin: 0 0 3px;
}
</style>
